const getNonceFromHeaders = (headers: any): string | undefined => {
  if (!headers) return undefined;

  // Fetch Headers instance (or compatible object).
  if (typeof headers.get === "function") {
    const nonce = headers.get("nonce");
    return typeof nonce === "string" ? nonce : undefined;
  }

  // Plain object headers (axios/common case).
  if (typeof headers !== "object") return undefined;

  // Case-insensitive key lookup to handle NONCE/Nonce/nonce variations.
  const nonceKey = Object.keys(headers).find(
    (key) => key.toLowerCase() === "nonce"
  );
  if (!nonceKey) return undefined;

  const rawNonce = headers[nonceKey];
  if (Array.isArray(rawNonce)) {
    return typeof rawNonce?.[0] === "string" ? rawNonce[0] : undefined;
  }

  return typeof rawNonce === "string" ? rawNonce : undefined;
};

export const getNonceHeaderValue = (response: any): string => {
  const nonce =
    // Standard axios response shape.
    getNonceFromHeaders(response?.headers) ??
    // Some wrappers nest headers under response.data.
    getNonceFromHeaders(response?.data?.headers) ??
    // Legacy/shared wrapper shape.
    getNonceFromHeaders(response?.data?.apiResponse?.headers);

  return nonce || "";
};
